import backgroundVideo from "../../assets/images/backgroundProducts.mp4";
import "./style.css";
import { img1, img2, img3, img4, img5, img6, img7, img8 } from "../../assets/images/rems";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const remsDetails = {
  name: "REMS (Real Estate Management System)",
  description:
    "The Real Estate Management ERP is a cloud-based SaaS platform designed to streamline real estate operations with advanced multi-tenancy, branch-wise configurations, and role-based access control. Key features include Ballot Management for automated property allocation, Project Management to plan and track projects and milestones, Property Booking with payment plans and invoices, Accounting for financial management and reports, Procurement for vendor and purchase management, and Bank Transactions for accurate reconciliation. With powerful reporting, subscription-based scalability, and custom branding, this all-in-one solution enhances efficiency, transparency, and growth for real estate businesses.",
  images: [img1, img2, img3, img4, img5, img6, img7, img8],
};

const RealEstateManagementSystem = () => {
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 1,
    speed: 500
  };

  return (
    <div className="w-full relative h-full">
      {/* Background Section */}
      <section id="heading" className="relative flex">
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={backgroundVideo}
          autoPlay
          loop
          muted
          style={{ opacity: "0.25" }}
        />

        {/* Heading Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-center h-screen z-10">
          <h1 className="text-4xl lg:text-5xl font-bold text-center text-white">
            <span className="gradient-headings">{remsDetails.name}</span>
          </h1>
          <p className="text-xl lg:text-2xl text-white mt-6 mx-auto max-w-4xl px-4 text-justify md:text-center">
            The <span className="font-bold">Real Estate Management ERP</span> is a cloud-based SaaS platform
            designed to streamline real estate operations with advanced multi-tenancy, branch-wise configurations,
            and role-based access control.
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="pb-10 px-4 md:px-8 bg-gradient-to-r from-slate-950/80 via-slate-950/90 to-slate-950/100">
        <div className="container mx-auto flex flex-col-reverse md:flex-col   gap-10 xl:gap-16 items-center">
          <div className="text-base lg:text-xl text-white px-4 xl:mt-24">
            <p className="text-justify">{remsDetails.description}</p>
          </div>
          <div className="w-full px-4 slider-container">
            <Slider {...settings}>
              {remsDetails.images.map((image, index) => (
                <div key={index} className="">
                  <img
                    src={image}
                    alt="product images"
                    className="w-full h-auto rounded-lg shadow-lg object-cover"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>


      
    </div>
  );
};

export default RealEstateManagementSystem;
